import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useStatistikPresensi, usePresensiUpdate, usePesertaWithPresensi } from '@/hooks/usePresensi'
import { useAuth } from '@/hooks/useAuth'
import PresensiList from '@/components/presensi/PresensiList'
import EmptyState from '@/components/ui/EmptyState'

export default function PresensiPage() {
  const { id: kegiatanId } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { isSuperAdmin, isStadion } = useAuth()
  const { data: peserta = [], isLoading } = usePesertaWithPresensi(kegiatanId)
  const { data: statistik } = useStatistikPresensi(kegiatanId)
  const updateMutation = usePresensiUpdate()

  const handleAttendanceChange = async (pesertaId: string, status: 'hadir' | 'alpha' | 'izin') => {
    if (!kegiatanId) return
    try {
      await updateMutation.mutateAsync({ pesertaId, kegiatanId, status })
    } catch (err) {
      console.error('Presensi update error:', err)
    }
  }

  if (!isSuperAdmin && !isStadion) {
    return (
      <div className="py-4">
        <EmptyState
          title="Akses Ditolak"
          description="Hanya Stadion dan Super Admin yang dapat melakukan presensi."
          action={{ label: 'Kembali', onClick: () => navigate(-1) }}
        />
      </div>
    )
  }

  if (isLoading) {
    return (
      <div className="py-4 space-y-3">
        <div className="bg-white rounded-card h-24 animate-pulse" />
        <div className="bg-white rounded-card h-48 animate-pulse" />
      </div>
    )
  }

  return (
    <div className="py-4">
      <PresensiList
        peserta={peserta}
        statistik={statistik}
        onAttendanceChange={handleAttendanceChange}
        loading={updateMutation.isPending}
      />
    </div>
  )
}
